export function resolveSafeNextPath(requestedNext: string | null | undefined, fallbackPath: string): string {
  if (!requestedNext) return fallbackPath;
  return requestedNext.startsWith("/") ? requestedNext : fallbackPath;
}

export function buildAuthCallbackUrl(origin: string, nextPath: string): string {
  const url = new URL("/auth/callback", origin);
  url.searchParams.set("next", nextPath);
  return url.toString();
}
